import { ResultOf } from 'gql.tada';
import { mapApiWeblinkIconInfoToLinkIconInfo } from '../../../../app-kit/helpers/mapApiWeblinkIconInfoToLinkIconInfo';
import { mapApiWeblinkVariantToLinkVariant } from '../../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { mapButtonVariant } from '../../../../app-kit/helpers/mapButtonVariant';
import { mapIconName } from '../../../../app-kit/helpers/mapIconName';
import { isNotNullOrUndefinedValue } from '../../../../helpers/isNotNullOrUndefinedValue';
import { propertyPagePageHeaderFragment } from '../../../graphql/propertyPageQuery';
import type { UpdatePropertyDetailsHeaderProps } from '../subcomponents/UpdatePropertyDetailsHeader/UpdatePropertyDetailsHeader';

type HeaderType = NonNullable<ResultOf<typeof propertyPagePageHeaderFragment>['header']>;
type PropertyFeaturesContainer = NonNullable<Pick<HeaderType, 'propertyFeatures'>>;
type PropertyFeatures = NonNullable<PropertyFeaturesContainer['propertyFeatures']>;
type PropertyPage_UpdatePropertyDetailsCta = PropertyFeatures['updatePropertyDetailsCta'];

export const mapHeaderUpdatePropertyDetailsCta = (
  updatePropertyDetailsCta?: PropertyPage_UpdatePropertyDetailsCta,
): UpdatePropertyDetailsHeaderProps | undefined => {
  if (!isNotNullOrUndefinedValue(updatePropertyDetailsCta)) return undefined;
  if (updatePropertyDetailsCta?.__typename === 'PropertyPage_UpdatePropertyDetailsModalCta') {
    return {
      cta: {
        ...updatePropertyDetailsCta,

        button: {
          ...updatePropertyDetailsCta.button,
          sizeVariant: updatePropertyDetailsCta.button.sizeVariant ?? undefined,
          icon: mapIconName(updatePropertyDetailsCta.button.iconName),
          variant: mapButtonVariant(updatePropertyDetailsCta.button.buttonVariant),
          iconPlacement: updatePropertyDetailsCta.button.iconPlacement ?? undefined,
        },
      },
    };
  }

  if (updatePropertyDetailsCta?.__typename === 'PropertyPage_SignUpToUpdatePropertyDetailsCta') {
    return {
      cta: {
        ...updatePropertyDetailsCta,
        link: {
          ...updatePropertyDetailsCta.link,
          variant:
            mapApiWeblinkVariantToLinkVariant(updatePropertyDetailsCta.link.variant) ?? undefined,
          iconInfo: updatePropertyDetailsCta.link.iconInfo
            ? mapApiWeblinkIconInfoToLinkIconInfo(updatePropertyDetailsCta.link.iconInfo)
            : null,
        },
      },
    };
  }

  return undefined;
};
